import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "./index.css";
import App from "./App";
import { history, store, persistor } from "./common/store/configureStore";

import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { render } from "react-dom";
import { ConnectedRouter } from "connected-react-router";
import { Notifications } from 'react-push-notification';

// console.log("PMK store ", store);
// console.log("PMK persistor ", persistor);
// ReactDOM.render(
//   <React.StrictMode>
//      <Provider store={store}>
//      <PersistGate loading={true} persistor={persistor}></PersistGate>
//    <Routes />
//    </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

class PikMyKid extends React.Component {
  componentDidMount = () => {
    this.clearCacheData()
  }
  // Function to clear complete cache data
  clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    console.log('Complete Cache Cleared')
  };
  render() {
    return (
      <Provider store={store}>
        <Notifications />
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <I18nextProvider i18n={i18n}>
              <App />
            </I18nextProvider>

          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("firebase-messaging-sw.js")
//     .then(function(registration) {
//       console.log("Registration successful, scope is:", registration.scope);
//     })
//     .catch(function(err) {
//       console.log("Service worker registration failed, error:", err);
//     });
// }

const reactRoot = document.getElementById("root");

render(<PikMyKid />, reactRoot);
